import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Category } from '../../../../../shared/issuesV2';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import TeamsModule from '../../../../redux/teams';
import type { TeamSelection } from '../../../../types';

/**
 * Hook which is responsible for fetching the category summary when the component mounts,
 * as well as when the categorySummary changes.
 *
 * categorySummary is set to `null` when the scope changes/is updated, which causes
 * it to be re-fetched with the updated scope. Same for just changing the scope's scanId.
 * This gives the state a chance to update with the correct scope before we fetch.
 *
 * The scope itself is set by useSetIssuesScope in various locations.
 */
const useIssuesLicenseList = () => {
  const dispatch = useDispatch();
  const category = useSelector(IssuesV2Store.selectors.getIssueCategory);
  const teamIds = useSelector(TeamsModule.selectors.getTeamSelection);
  const prevTeamIds = useRef<TeamSelection>(teamIds);
  const status = useSelector(IssuesV2Store.selectors.getStatus);

  // https://github.com/fossas/FOSSA/blob/73d864ffcfabd6a7280ff13543225a75f9c717be/app/redux/issuesV2/reducer.unit.spec.ts#L640
  //  Whenever categorySummary changes and is null, we re-fetch.
  //  See the actions which update the scope to see where this is set to null.
  useEffect(() => {
    if (category === Category.Licensing || teamIds !== prevTeamIds.current) {
      prevTeamIds.current = teamIds;
      dispatch(IssuesV2Store.actions.fetchIssueLicenseList());
    }
  }, [category, dispatch, teamIds, status]);
};

export default useIssuesLicenseList;
